import React, { FC } from 'react';
import * as Styled from './styled';
import { BackToTopButtonProps } from './types';

const BackToTopButton: FC<BackToTopButtonProps> = ({ showBackToTopButton, left, handleBackToTop }) => (
  <Styled.BackToTopButton
    data-testid="btn"
    $hasBackToTopButton={showBackToTopButton}
    $left={left}
    variant="secondary"
    role="button"
    size="small"
    leadingIcon="arrow-up"
    onlyIcon
    onClick={handleBackToTop}
  />
);

export default BackToTopButton;
